import { render, staticRenderFns } from "./setPhone.vue?vue&type=template&id=3e86409b"
import script from "./setPhone.vue?vue&type=script&lang=js"
export * from "./setPhone.vue?vue&type=script&lang=js"
import style0 from "./setPhone.vue?vue&type=style&index=0&id=3e86409b&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports